import React, { useState } from "react"
import * as Style from "./SearchInput.module.scss"
import SearchIcon from "../../images/search_icon.svg"

const SearchInput = ({ sendChildData }) => {
  const handleInput = event => {
    sendChildData(event.target.value)
  }

  return (
    <div className={Style.wrapper}>
      <div className={Style.label}>Търсачка</div>
      <div className={Style.text_field}>
        <SearchIcon />
        <input onChange={event => handleInput(event)} />
      </div>
    </div>
  )
}

export default SearchInput
